import { useRef, useState } from "react";

export const GrainButton = ({ children, onClick, testid, className = "", small = false }) => {
  const ref = useRef(null);
  const [pos, setPos] = useState({ x: 0, y: 0 });

  const onMove = (e) => {
    const r = ref.current?.getBoundingClientRect();
    if (!r) return;
    setPos({
      x: ((e.clientX - r.left) / r.width - 0.5) * 8,
      y: ((e.clientY - r.top) / r.height - 0.5) * 6,
    });
  };

  return (
    <button
      ref={ref}
      data-testid={testid}
      onClick={onClick}
      onMouseMove={onMove}
      onMouseLeave={() => setPos({ x: 0, y: 0 })}
      style={{ transform: `translate(${pos.x}px, ${pos.y}px)` }}
      className={`group relative overflow-hidden rounded-full text-white font-semibold tracking-wide transition-[transform,box-shadow] duration-300 ease-out hover:shadow-[0_10px_36px_rgba(240,90,36,0.45)] ${
        small ? "px-5 py-2.5 text-xs" : "px-7 py-3.5 text-sm"
      } ${className}`}
    >
      <span className="texture-grain absolute inset-0 transition-all duration-500 group-hover:scale-110 group-hover:brightness-125" />
      <span className="absolute inset-0 bg-ember/20 mix-blend-multiply transition-opacity duration-500 group-hover:opacity-0" />
      <span className="relative z-10 flex items-center gap-2 whitespace-nowrap">{children}</span>
    </button>
  );
};
